import CharacterCount from "@tiptap/extension-character-count";
import type { Extensions } from "@tiptap/react";
import type { EditorProps } from "../types/editor";
import { UtilityExtension } from "./utility";
import { CustomMentionExtension } from "./mentions/extention";
import { CustomStarterKitExtension } from "./starter-kit";
import { CustomPlaceholderExtension } from "./placeholder";
import { ListKeymap } from "./custom-list-keymap";

type Arguments = Pick<
  EditorProps,
  "isTouchDevice" | "mentionHandler" | "placeholder" | "tabIndex"
> & {
  editable: boolean;
  uploadImage?: (file: File) => Promise<string>;
};

export const CoreEditorExtensions = (args: Arguments): Extensions => {
  const {
    isTouchDevice = false,
    mentionHandler,
    editable,
    placeholder,
    tabIndex,
    uploadImage
  } = args;

  const extensions: Extensions = [
    CustomStarterKitExtension(),
    ListKeymap({ tabIndex }),
    ...(mentionHandler ? [CustomMentionExtension(mentionHandler)] : []),
    CustomPlaceholderExtension({ placeholder }),
    CharacterCount,
    UtilityExtension({ isEditable: editable, isTouchDevice, uploadImage })
  ];

  return extensions;
};
